<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <v-card class="card0">
        <h4>Internet Bills</h4>
        <v-card flat class="card1">
          <small
            >Select Network : <b class="nett">{{ network }}</b></small
          >
          <v-card flat class="cardDiv">
            <div @click="Setnetwork('Spectranet')" class="network">
              <img
                src="../assets/spectranet.png"
                alt="teller logo"
                width="70"
                height="65"
              />
            </div>
            <div @click="Setnetwork('Smile')" class="network">
              <img
                src="../assets/smile.png"
                alt="teller logo"
                width="70"
                height="65"
              />
            </div>
          </v-card>
          <v-row>
            <v-col>
              <div class="labelDiv">
                <label><b>Select Bundle</b></label>
              </div>
              <div v-if="network == 'Spectranet'" class="selectDiv">
                <v-select
                  v-model="serviceCode"
                  item-text="label"
                  :items="Spectranet"
                  solo
                  append-icon="mdi-menu-down"
                >
                </v-select>
              </div>
              <div v-else class="selectDiv">
                <v-select
                  v-model="serviceCode"
                  item-text="label"
                  :items="Smile"
                  solo
                  append-icon="mdi-menu-down"
                >
                </v-select>
              </div>
              <div class="labelDiv">
                <label><b>Customer Phone number</b></label>
              </div>
              <v-text-field
                v-model="phoneNumber"
                class="field"
                outlined
              ></v-text-field>
              <v-btn block class="nextBtn" dark @click="loadInternetDetail()">
                Next
              </v-btn>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-dialog v-model="InternetDialog" persistent max-width="500">
              <InternetDetail
                :phoneNumber="this.phoneNumber"
                :network="this.network"
                :serviceCode="this.serviceCode"
              />
            </v-dialog>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-card>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";
import InternetDetail from "../components/InternetDetail";

export default {
  metaInfo: {
    title: "Teller/Internet",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    Profile: Profile,
    InternetDetail: InternetDetail,
  },
  computed: {
    InternetDialog() {
      return this.$store.getters.getInternetDialog;
    },
  },
  methods: {
    Setnetwork(payload) {
      this.network = payload;
    },
    loadInternetDetail() {
      if (this.network == "" || this.phoneNumber == "") {
        let payload = {
          status: true,
          message: "Fill out all the required fields",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }
      let payload = { network: this.network, serviceCode: this.serviceCode };
      this.$store.dispatch("loadInternetDetail", payload);
    },
  },
  data() {
    return {
      dialog: false,
      phoneNumber: "",
      serviceCode: "",
      network: "Spectranet",
      Smile: [
        {
          value: "160",
          label: "SmileVoice ONLY 135 1000",
          network: "Smile",
        },
        {
          value: "161",
          label: "1.5GB ValuePlus Plan 1000",
          network: "Smile",
        },
        {
          value: "162",
          label: "Flexi Weekly plan 1000",
          network: "Smile",
        },
        {
          value: "163",
          label: "2GB MidNite Plan 1000",
          network: "Smile",
        },
        {
          value: "164",
          label: "3GB MidNite Plan 1500",
          network: "Smile",
        },
        {
          value: "165",
          label: "3GB Weekend Only Plan 1500",
          network: "Smile",
        },
        {
          value: "166",
          label: "SmileVoice ONLY 430 3000",
          network: "Smile",
        },
        {
          value: "167",
          label: "5GB ValuePlus Plan 3000",
          network: "Smile",
        },
        {
          value: "168",
          label: "7GB ValuePlus Plan\r\n 4000",
          network: "Smile",
        },
        {
          value: "169",
          label: "11GB ValuePlus Plan 5000",
          network: "Smile",
        },
        {
          value: "170",
          label: "15GB ValuePlus Plan 6000",
          network: "Smile",
        },
        {
          value: "171",
          label: "21GB ValuePlus Plan 8000",
          network: "Smile",
        },
        {
          value: "172",
          label: "10GB AnytimePlan 8000",
          network: "Smile",
        },
        {
          value: "173",
          label: "Unlimited Lite Plan 10000",
          network: "Smile",
        },
        {
          value: "174",
          label: "31GB ValuePlus Plan 11000",
          network: "Smile",
        },
        {
          value: "175",
          label: "UnlimitedEssential Plan 15000",
          network: "Smile",
        },
        {
          value: "176",
          label: "30GB BumpaValue plan 15000",
          network: "Smile",
        },
        {
          value: "177",
          label: "20GB AnytimePlan 16000",
          network: "Smile",
        },
        {
          value: "178",
          label: "Unlimited PremiumPlan 19800",
          network: "Smile",
        },
        {
          value: "179",
          label: "60GB BumpaValue plan 30000",
          network: "Smile",
        },
        {
          value: "180",
          label: "50GB Anytime plan 36000",
          network: "Smile",
        },
        {
          value: "181",
          label: "80GB Bumpa Value plan 40000",
          network: "Smile",
        },
        {
          value: "182",
          label: "100GB Anytime plan 70000",
          network: "Smile",
        },
        {
          value: "183",
          label: "200GB Anytime plan 135000",
          network: "Smile",
        },
        {
          value: "184",
          label: "Flexi Daily plan 350",
          network: "Smile",
        },
        {
          value: "185",
          label: "SmileVoice ONLY 65 500",
          network: "Smile",
        },
        {
          value: "186",
          label: "5GB ValuePlus Plan 2.15",
          network: "Smile",
        },
        {
          value: "187",
          label: "7GB ValuePlus Plan\r\n 3.22",
          network: "Smile",
        },
        {
          value: "188",
          label: "20GB AnytimePlan 16.12",
          network: "Smile",
        },
        {
          value: "189",
          label: "1.5GB ValuePlus Plan 1020",
          network: "Smile",
        },
        {
          value: "190",
          label: "Flexi Weekly plan 1020",
          network: "Smile",
        },
        {
          value: "191",
          label: "5GB ValuePlus Plan 3070",
          network: "Smile",
        },
        {
          value: "192",
          label: "7GB ValuePlus Plan\r\n 4090",
          network: "Smile",
        },
        {
          value: "193",
          label: "20GB AnytimePlan 16380",
          network: "Smile",
        },
        {
          value: "194",
          label: "SmileVoice ONLY 65 510",
          network: "Smile",
        },
        {
          value: "195",
          label: "SmileVoice ONLY 135 1020",
          network: "Smile",
        },
        {
          value: "196",
          label: "2GB MidNite Plan 1020",
          network: "Smile",
        },
        {
          value: "197",
          label: "3GB MidNite Plan 1530",
          network: "Smile",
        },
        {
          value: "198",
          label: "3GB Weekend Only Plan 1530",
          network: "Smile",
        },
        {
          value: "199",
          label: "SmileVoice ONLY 430 3070",
          network: "Smile",
        },
        {
          value: "200",
          label: "11GB ValuePlus Plan 5110",
          network: "Smile",
        },
        {
          value: "201",
          label: "15GB ValuePlus Plan 6140",
          network: "Smile",
        },
        {
          value: "202",
          label: "21GB ValuePlus Plan 8190",
          network: "Smile",
        },
        {
          value: "203",
          label: "10GB AnytimePlan 8190",
          network: "Smile",
        },
        {
          value: "204",
          label: "Unlimited Lite Plan 10230",
          network: "Smile",
        },
        {
          value: "205",
          label: "31GB ValuePlus Plan 11260",
          network: "Smile",
        },
        {
          value: "206",
          label: "UnlimitedEssential Plan 15350",
          network: "Smile",
        },
        {
          value: "207",
          label: "30GB BumpaValue plan 15350",
          network: "Smile",
        },
        {
          value: "208",
          label: "Unlimited PremiumPlan 20270",
          network: "Smile",
        },
        {
          value: "209",
          label: "60GB BumpaValue plan 30700",
          network: "Smile",
        },
        {
          value: "210",
          label: "50GB Anytime plan 36850",
          network: "Smile",
        },
        {
          value: "211",
          label: "80GB Bumpa Value plan 40950",
          network: "Smile",
        },
        {
          value: "212",
          label: "100GB Anytime plan 71650",
          network: "Smile",
        },
        {
          value: "213",
          label: "200GB Anytime plan 138200",
          network: "Smile",
        },
        {
          value: "214",
          label: "UnlimitedPlatinum Plan 24000",
          network: "Smile",
        },
        {
          value: "215",
          label: "1.GB day use + 500MB night use 1020",
          network: "Smile",
        },
        {
          value: "216",
          label: "5GB with 50% day + 50% night use 3070",
          network: "Smile",
        },
        {
          value: "217",
          label: "7GB with 50% day + 50% night use 4090",
          network: "Smile",
        },
        {
          value: "218",
          label: "11GB with 50% day + 50% night use 5110",
          network: "Smile",
        },
        {
          value: "219",
          label: "15GB with 50% day + 50% night use 6140",
          network: "Smile",
        },
        {
          value: "220",
          label: "21GB with 50% day + 50% night use 8190",
          network: "Smile",
        },
        {
          value: "221",
          label: "31GB with 50% day + 50% night use 11260",
          network: "Smile",
        },
      ],
      Spectranet: [
        {
          value: "78",
          label: "500",
          network: "Spectranet",
        },
        {
          value: "79",
          label: "1000",
          network: "Spectranet",
        },
        {
          value: "80",
          label: "2000",
          network: "Spectranet",
        },
        {
          value: "81",
          label: "5000",
          network: "Spectranet",
        },
        {
          value: "82",
          label: "7000",
          network: "Spectranet",
        },
        {
          value: "83",
          label: "10000",
          network: "Spectranet",
        },
      ],
    };
  },
};
</script>
<style scoped>
.cardTr {
  display: flex;
  align-items: center;
  padding: 15px;
  padding-right: 20px;
  padding-left: 20px;
  height: 100px;
  border-radius: 20px !important;
  margin-right: 20px;
  margin-left: 20px;
  cursor: pointer;
}
.bg {
  background-color: rgba(235, 87, 87, 0.2);
}
.init {
  margin-left: 15px;
}
.padd {
  padding: 10px;
  border-radius: 10px;
}
.bankT {
  text-align: center;
  color: #ad1684;
}
.btn {
  background-color: #ad1684 !important;
  text-transform: none;
}

.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody";
}

.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  display: flex;
  justify-content: center;
  padding: 50px;
  padding-top: 70px;
}
.mainBody h4 {
  color: #ad1684;
  margin-top: 10px;
}
.Transaction {
  grid-area: Transaction;
  background-color: #ffffff;
}
.card {
  margin-top: 50px;
  border-radius: 20px !important;
  height: 500px;
}
.cardTr {
  display: flex;
  align-items: center;
  padding: 15px;
  padding-right: 20px;
  padding-left: 20px;
  height: 100px;
  border-radius: 20px !important;
  margin-right: 20px;
  margin-left: 20px;
}
.bg {
  background-color: rgba(235, 87, 87, 0.2);
}
.bg1 {
  background-color: rgba(187, 107, 217, 0.3);
}
.ImgTrans {
  background-image: url("../assets/Tbg.png");
  height: 140px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.select {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  background-color: #e3e3e3;
}
.selectDiv {
  position: relative;
  margin-bottom: 10px;
}
.selectarrow {
  position: absolute;
  top: 15px;
  right: 10px;
  background-color: #ad1684;
}
.trans {
  display: flex;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
}
.trans h4 {
  color: white;
}
.trans small {
  color: white;
  text-decoration-line: underline;
}
.card1 {
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  padding: 30px;
}
.card0 {
  padding: 30px;
  width: 500px;
  border-radius: 15px !important;
}
.card0 h4 {
  margin-left: 30px;
}
.cardv {
  height: 450px;
}
.cardRR {
  height: 300px;
  overflow: scroll;
  padding-bottom: 10px;
}
.init {
  margin-left: 15px;
}
.cardDiv {
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  border-radius: 10px !important;
  background-color: rgba(189, 36, 91, 0.1);
}
.network {
  cursor: pointer;
}
.flag {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flag img {
  margin-right: 3px;
}
.nextBtn {
  background-color: #ad1684 !important;
  border-radius: 10px;
  text-transform: none;
}
.field {
  width: 400px;
}
.nett {
  text-transform: uppercase;
}
@media only screen and (max-width: 1024px) {
  .main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(90px, auto);
    margin: 0 auto;
    padding: 0px;
    grid-template-areas:
      "profileHeader profileHeader profileHeader"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody";
  }
  .Transaction {
    display: none;
  }
  img {
    width: 40px;
    height: 40px;
  }
  .card0 {
    padding: 10px;
    border-radius: 15px !important;
  }
  .mainBody {
    grid-area: mainBody;
    background-color: #ffffff;
    border-bottom-left-radius: 40px;
    padding: 30px;
    padding-top: 70px;
  }
  .field {
    width: 250px;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
